import * as React from 'react';
import {connect} from 'react-redux';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as HistoryModule from 'Modules/HistoryModule';
import * as MapModule from 'Modules/MapModule';
import {Map, TileLayer} from 'react-leaflet';
import {mapBounds, minZoom, maxZoom, mapOptions, osmURL} from 'components/Map/MapHelpers/MapHelpers';
import {withTranslation} from 'react-i18next';
import {Cell, InfiniteTableForDataframes} from 'HelperFunctions/Lists';
import {LatestDataframeRides} from 'components/Map/History/HistoryRides';
import ZoomManagement from 'components/Map/MapHelpers/ZoomManagement';
import * as L from 'leaflet';
import MediaQuery from 'react-responsive';
import i18next from 'i18next';
import {IPaginatedList} from "Models/PaginatedList";
import {DEFAULT_PAGE_SIZE_FOR_HISTORY} from "../../constants";
import {compose} from "redux";
import { RouteComponentProps } from 'react-router'
import {RootState} from "Redux/Reducers/_RootReducer";
import {RefObject} from "react";
import ReactTable from "react-table";

type Props = RouteComponentProps<{ carId?: string }>

type ConnectedDispatch = {
    getCarDetails: (carId: number) => void;
    //setActiveDataframe: (dataframe: VehiclesModule.Types.CarDataframeDto) => void;
    smallMapsetMapCenter: (center: MapModule.Types.MapCenter) => void;
    smallMapsetMapZoom: (zoom: number) => void;
    onFetchDataframes: (...args: Parameters<typeof HistoryModule.Actions.getLatestDataframes>) => Promise<void>
    clearLastDataframesQuery: () => void
};

type ConnectedProps = {
    vehiclesStore: VehiclesModule.Types.VehiclesStore;
    mapStore: MapModule.Types.MapStore;
    latestDataframes: IPaginatedList<VehiclesModule.Types.CarDataframeDto>
    latestDataframesQuery: URLSearchParams
    activeDataframe: VehiclesModule.Types.CarDataframeDto;
    t?: i18next.TFunction;
    latestDataframesManualHandling: boolean;
};
type State = {
    refEnabled: boolean;
};

class CarHistory extends React.Component<Props & ConnectedProps & ConnectedDispatch, State> {
    private mapRef: L.Map;
    private tableRef: RefObject<ReactTable<VehiclesModule.Types.CarDataframeDto>>;
    private componentMapRef: any;

    constructor(props: Props & ConnectedProps & ConnectedDispatch) {
        super(props);
        this.state = {
            refEnabled: false
        };
        this.tableRef = React.createRef();

        this.handleRef = this.handleRef.bind(this);
        this.handleRowclick = this.handleRowclick.bind(this);
        this.handleFetchDataframes = this.handleFetchDataframes.bind(this);
    }

    public async componentDidMount() {
        const {carId} = this.props.match.params;
        const {getCarDetails} = this.props;
        if (!this.props.vehiclesStore.singleCarViewData) {
            await getCarDetails(carId as unknown as number);
        }
    }

    public componentDidUpdate(prevProps: Readonly<Props & ConnectedProps & ConnectedDispatch>) {
      const prevFirst = prevProps.latestDataframesQuery?.get('first')
      const currentFirst = this.props.latestDataframesQuery?.get('first')
      if (prevFirst !== currentFirst && Number(currentFirst) === 0) {
        this.tableRef.current.setState({ page: 0 })
      }
    }

  public async componentWillUnmount() {
      this.props.clearLastDataframesQuery()
    }
    private handleRef(ref: any) {
        if (ref) {
            this.componentMapRef = ref;
            this.mapRef = ref.leafletElement;
        }
    }

    private handleRowclick(dataframe: VehiclesModule.Types.CarDataframeDto) {
        //this.props.setActiveDataframe(dataframe);
        this.props.smallMapsetMapZoom(14);
        this.props.smallMapsetMapCenter({lat: dataframe.latitude, lng: dataframe.longitude});
    }

    public handleFetchDataframes(tableState: any,) {
      // This means if max is set to MAX_ROWS_FOR_FETCH_FULL_LIST you should paginate data on frontend,
      // not from backend because user want to see all trace on map.
      if (this.props.latestDataframesQuery === null || !this.props.latestDataframesManualHandling) {
        return
      }

      this.props.onFetchDataframes(this.props.match.params.carId as unknown as number, {
        first: tableState.page * DEFAULT_PAGE_SIZE_FOR_HISTORY
      });
    }

    public render() {
        const {mapStore, t} = this.props;
        return (
            <div className="main main__content main__content--no-padding">
                <div className="main__inner-left">
                    <h3 className="main__title">{t('carHistory')}</h3>
                    <MediaQuery query="(min-width: 1280px)">
                        <InfiniteTableForDataframes
                          innerRef={this.tableRef}
                          listData={this.props.latestDataframes?.results}
                          onRowClick={this.handleRowclick}
                          activeDataframeID={this.props.activeDataframe}
                          totalCount={this.props.latestDataframes?.totalCount ?? 0}
                          onFetchData={this.handleFetchDataframes}
                          manual={this.props.latestDataframesManualHandling}
                        />
                    </MediaQuery>
                </div>
                <div className="main__inner-right clear-padding">
                    <Map
                        preferCanvas
                        center={mapStore.smallMap.center}
                        zoom={mapStore.smallMap.zoom}
                        onZoomEnd={zoomObj => {
                            this.props.smallMapsetMapZoom(zoomObj.target._zoom);
                        }}
                        options={mapOptions}
                        maxZoom={maxZoom}
                        minZoom={minZoom}
                        zoomControl={false}
                        maxBounds={mapBounds}
                        ref={this.handleRef}
                    >
                        <TileLayer url={osmURL} preferCanvas/>
                        <LatestDataframeRides
                            componentMapRef={this.componentMapRef}
                            mapRef={this.mapRef}
                            latestDataframes={this.props.latestDataframes?.results || []}
                            activeCar={this.props.vehiclesStore.singleCarViewData ? this.props.vehiclesStore.singleCarViewData.car : null}
                        />
                    </Map>
                  <div className="map-manage">
                    <ZoomManagement small/>
                  </div>
                </div>
                <MediaQuery query="(max-width: 1279px)">
                    <div className="main__inner-right">
                        <InfiniteTableForDataframes
                          innerRef={this.tableRef}
                          listData={this.props.latestDataframes?.results}
                          onRowClick={this.handleRowclick}
                          activeDataframeID={this.props.activeDataframe}
                          totalCount={this.props.latestDataframes?.totalCount ?? 0}
                          onFetchData={this.handleFetchDataframes}
                        />
                    </div>
                </MediaQuery>
            </div>
        );
    }
}

function mapStateToProps(state: RootState): ConnectedProps {
    return {
        vehiclesStore: state.vehiclesStore,
        latestDataframes: state.historyStore.latestDataframes,
        latestDataframesQuery: state.historyStore.latestDataframesQuery,
        activeDataframe: state.historyStore.activeDataframe,
        mapStore: state.mapStore,
      latestDataframesManualHandling: state.historyStore.latestDataframesManualHandling
    };
}

function mapDispatchToProps(dispatch: any): ConnectedDispatch {
    return {
        getCarDetails: (carId: number) => dispatch(VehiclesModule.Actions.getSingleCarDetails(carId)),
        //setActiveDataframe: (dataframe: VehiclesModule.Types.CarDataframeDto) => dispatch(HistoryModule.Actions.setActiveDataframe(dataframe)),
        smallMapsetMapCenter: (center: MapModule.Types.MapCenter) => dispatch(MapModule.Actions.smallMapsetMapCenter(center)),
        smallMapsetMapZoom: (zoom: number) => dispatch(MapModule.Actions.smallMapsetMapZoom(zoom)),
        onFetchDataframes: (cardId, queryData) => dispatch(HistoryModule.Actions.getLatestDataframes(cardId, queryData)),
        clearLastDataframesQuery: () => dispatch(HistoryModule.Actions.clearLastDataframesQuery()),
    };
}

export default
  compose(
    withTranslation('carDetails'),
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
  )(CarHistory)




// WEBPACK FOOTER //
// ./src/components/CarsManagement/CarHistory.tsx